import React, { Component } from 'react';
import moment from 'moment-with-locales-es6';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import InfiniteScroll from 'react-infinite-scroll-component';

import { connect} from "remx";
import broker from '../../../utils/broker';
import config from '../../../utils/config';

import dataStore from '../../../stores/data';

// import ChartPelanggan from './ChartPelanggan';
import ChartPelanggan from './ChartPelanggan_';
import SidebarTree from '../SidebarTree';

class MonitoringPerTanggal extends Component {
    constructor(props) {
        super(props);
    
    this.options = {

    }

    this.state = {
            reload:false,
            loading: false,
            id_pk_column: 'id',
            detail_kategori : {},
            data_pelanggan : [],
            show_graphic : false,
            data_meta: {current_page: 0, from : 0, last_page: 0, per_page: 0, total: 0, to : 0},
            download : false,
            url_report: '',
            page_index:1,
            date: [new Date(), new Date()],
        }
    }

    prevNextDay(count){
        var type_view = this.props.type_view;
        var date = this.props.date_view;
        if (type_view === 'month'){
            date = moment(date).add(count, 'month');
        } else {
            date = moment(date).add(count, 'days');
        }
        dataStore.setters.setDataDateView(moment(date).locale('id').format('YYYY-MM-DD'));
        dataStore.setters.setDataMonthView(parseInt(moment(date).locale('id').format('MM'))-1);
        this.setState({prev_next : (count === (+1)) ? 'next' : 'prev'});
    }

    setDataType(type) {
        dataStore.setters.setDataTypeView(type);
    }

    setNow(){
        dataStore.setters.setDataDateView(moment().locale('id').format('YYYY-MM-DD'));
        dataStore.setters.setDataTypeView('day');
        dataStore.setters.setDataMonthView(parseInt(moment().locale('id').format('MM'))-1);
        this.setState({prev_next : ''});
    }
    
    componentDidMount(){
        var addScript = document.createElement('script');
        addScript.setAttribute('src', '/assets/js/dashforge.filemgr_.js');
        document.body.appendChild(addScript);

        if (this.props.data_kategori_per.id_kategori) {
            this.getDataKategoriPer();
            this.getDataPelanggan();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.data_kategori_per !== prevProps.data_kategori_per){
            this.getDataPelanggan();
            this.getDataKategoriPer();
        }

        if (this.state.date !== prevState.date ||
            this.props.pelanggan_id !== prevProps.pelanggan_id ||
            this.props.data_kategori_per !== prevProps.data_kategori_per) {
              
            this.setState({show_graphic: false});
            // dataStore.setters.setDataExport([]);
            this.getDataPelanggan();
        }

    }

    getDataPelanggan(){
        this.setState({loading : true})
        broker.fetch.get(`data/kategori/${this.props.data_kategori_per.id_kategori}/pelanggan_date?page=1&date_start=${moment(this.state.date[0]).locale('id').format('YYYY-MM-DD')}&date_end=${moment(this.state.date[1]).locale('id').format('YYYY-MM-DD')}&klasifikasi_id=${this.props.data_klasifikasi.klasifikasi_id}`)
        .then(res => {
            const { data } = res.data;
            if (data) {
                this.setState({
                    data_pelanggan: data.data,
                    page_index : 1,
                    data_meta: {
                        current_page: data.current_page,
                        from : data.from,
                        to : data.to,
                        last_page : data.last_page,
                        per_page : data.per_page,
                        total : data.total,
                    },
                    loading: false
                });
            } else {

            }
        }).catch(err => {
            
        });
    }

    fetchDataPelanggan(){
        broker.fetch.get(`data/kategori/${this.props.data_kategori_per.id_kategori}/pelanggan_date?page=${this.state.page_index}&date_start=${moment(this.state.date[0]).locale('id').format('YYYY-MM-DD')}&date_end=${moment(this.state.date[1]).locale('id').format('YYYY-MM-DD')}&klasifikasi_id=${this.props.data_klasifikasi.klasifikasi_id}`)
        .then(res => {
            const { data } = res.data;
            if (data) {
                // this.setState({data_pelanggan : data.data})
                this.setState({
                    data_pelanggan: this.state.data_pelanggan.concat(data.data),
                    data_meta: {
                        current_page: data.current_page,
                        from : data.from,
                        to : data.to,
                        last_page : data.last_page,
                        per_page : data.per_page,
                        total : data.total,
                    }
                });
            } else {

            }
        }).catch(err => {
            
        });
    }
    

    getDataKategoriPer(){
        broker.fetch.get(`data/kategori/${this.props.data_kategori_per.id_kategori}`)
        .then(res => {
            const { data } = res.data;
            if (data) {
                this.setState({detail_kategori : data})
            } else {

            }
        }).catch(err => {
            
        });
    }

    toggleShow(){
        if (this.state.data_pelanggan.length > 0) {
            this.setState({ show_graphic : !this.state.show_graphic, url_report: ''});
            dataStore.setters.setDataExport([]);
        }
            
    }

    fetchMoreData = () => {
        if (this.state.data_meta.last_page > this.state.page_index){
            setTimeout(() => {
                var page = this.state.page_index + 1
                this.setState({page_index: page}, function(){
                    this.fetchDataPelanggan();
                })
            }, 1500);
        }
    };

    downloadFile(){
        if (this.state.url_report === ''){
            this.generateReport();
        } else {
            window.open(config.api_support+'/download_report/'+this.state.url_report, "_blank")
            // console.log("download ")
        }
    }

    generateContent(){
        var content = this.state.detail_kategori;
        let return_content = [];
        if (content) {
            for (var key in content){
                if(!key.includes('id') && !key.includes('created_at') && !key.includes('updated_at'))
                    return_content.push(<React.Fragment key={key}>
                                            <label className="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase" key={key}>{key.replace("_", " ")}</label>
                                            <p className="tx-13 mg-b-10">{content[key]}</p>
                                        </React.Fragment>);
    
            }
        }

        return return_content;
    }

    onChange = date => this.setState({ date })

    render(){
        return(
            <div className="contact-wrapper">
                <SidebarTree />
                <div className="filemgr-content">
                    <div className="chat-content-header" style={{marginTop: '-5px'}}>
                        <div>
                            <h6 id="channelTitle" className="mg-b-0">#MonitoringPerTanggal</h6>
                        </div>  
                        <div className="d-none d-md-block  mg-r-300">
                            <DateRangePicker
                                onChange={this.onChange}
                                value={this.state.date} className="mg-r-10"/>
                            <button onClick={()=> this.toggleShow()} 
                                    className={"btn btn-sm btn-white mg-r-10"} 
                                    disabled={(this.state.show_graphic || this.state.loading ? true : false)}>
                                        Show Graphic
                            </button>
                        </div>
                        
                    </div>
                    <div className="contact-content-body" id="contact-content-body" style={{backgroundColor: 'white', overflow: 'auto'}}>
                        <React.Fragment>
                            <div className="container" style={{width:'1000px'}}>
                                <InfiniteScroll
                                    dataLength={this.state.data_pelanggan.length}
                                    next={this.fetchMoreData}
                                    hasMore={true}
                                    // loader={<h4>Please wait...</h4>}
                                    scrollableTarget="contact-content-body"
                                >
                                    {(this.state.data_pelanggan.length > 0 && this.state.show_graphic === true) &&
                                        this.state.data_pelanggan.map((data, i) => {
                                            return <ChartPelanggan
                                                        key={i} 
                                                        pelanggan_id={data.id} 
                                                        no_urut_pelanggan={data.no_urut_pelanggan}
                                                        klasifikasi={(data.klasifikasi) ? data.klasifikasi : ''} 
                                                        sub_klasifikasi={(data.sub_klasifikasi) ? data.sub_klasifikasi : ''}
                                                        date={this.state.date} 
                                                        show_graphic={this.state.show_graphic} 
                                            />
                                        })
                                    }
                                </InfiniteScroll>
                            </div>
                        </React.Fragment> 
                    </div>
                    <div className="contact-content-sidebar">
                        <label className="nav-label tx-color-03">Detail Data</label>
                        <hr className="mg-t-0"></hr>
                        {(this.state.detail_kategori) &&
                            this.generateContent()
                        }
                       
                    </div>
                </div>
            </div>
        );
    }

}

function mapStateToProps(props) {
    return {
        pelanggan_id : dataStore.getters.getDataPelangganId(),
        type_view : dataStore.getters.getDataTypeView(),
        year_view : dataStore.getters.getDataYearView(),
        month_view : dataStore.getters.getDataMonthView(),
        date_view : dataStore.getters.getDataDateView(),
        form_view : dataStore.getters.getDataFormView(),
        lat_lng : dataStore.getters.getLatLon(),
        data_pelanggan : dataStore.getters.getDataPelanggan(),
        data_kategori : dataStore.getters.getDataKategori(),
        data_kategori_per : dataStore.getters.getDataKategoriPer(),
        data_export : dataStore.getters.getDataExport(),
        data_klasifikasi: dataStore.getters.getDataKlasifikasi(),

    }
}


export default connect(mapStateToProps)(MonitoringPerTanggal);